import React, { FC, HTMLAttributes } from "react"

import * as S from "./PinterestSaveButton.styles"

interface PinterestSaveButtonProps
  extends Pick<HTMLAttributes<HTMLDivElement>, "onMouseEnter"> {
  className?: string
  description?: string
  image: string
  isVisible: boolean
  offsetLeft?: number
  offsetTop?: number
  url: string
}

export const PinterestSaveButton: FC<PinterestSaveButtonProps> = props => {
  const {
    className,
    description,
    image,
    isVisible,
    offsetLeft = 10,
    offsetTop = 10,
    onMouseEnter,
    url,
  } = props

  const mediaEncoded = encodeURIComponent(image)
  const urlEncoded = encodeURIComponent(
    /^\//.test(url) ? `https://avantstay.com/blog${url}` : url
  )

  let target = `https://www.pinterest.com/pin/create/button/?url=${urlEncoded}&media=${mediaEncoded}`

  if (description) {
    const descriptionEncoded = encodeURIComponent(description)
    target = `${target}&description=${descriptionEncoded}`
  }

  return (
    <S.Container
      className={className}
      isVisible={isVisible}
      offsetLeft={offsetLeft}
      offsetTop={offsetTop}
      onMouseEnter={onMouseEnter}
    >
      {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
      <a data-pin-do="buttonPin" href={target} />
    </S.Container>
  )
}
